<script>
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();

	export let title,
		props,
		pointer = "",
		qr = "";

	function findQR() {
		dispatch("qr", {
			qr: qr,
		});
	}

	function modifyProperty() {
		dispatch("modProp", {
			prop: { title, props },
		});
	}
</script>

{#if pointer == "y"}
	<div class="detail pointer" on:click={findQR}>
		<span>{title}</span>
		{#each props as prop}
			<span>{prop}</span>
		{/each}
	</div>
{:else}
	<div class="detail">
		<span>{title}</span>
		{#if typeof props === "string"}
			<input
				class="w-100"
				type="text"
				name="description"
				id="description"
				bind:value={props}
				on:change={modifyProperty}
			/>
		{:else}
			{#each props as prop}
				<input
					class="w-100"
					type="text"
					name="description"
					id="description"
					bind:value={prop}
				/>
			{/each}
		{/if}
	</div>
{/if}

<style>
	.detail input:first-child,
	.detail span:first-child {
		font-size: 25px;
	}

	.detail {
		height: 50px;
		width: 50%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	input {
		text-align: initial;
		border: none;
		padding: 0;
		width: 60%;
	}

	.pointer {
		cursor: pointer;
	}
</style>
